import UPInput from './UPInput';

export default UPInput;
